enum KioskAuthAppPaths {
  Login = '/',
  NotFound = '/*',
}

export default KioskAuthAppPaths;
